import type { Property } from "csstype";
import styled from "styled-components";

export interface IFlexContainerProps {
  inline?: boolean;
  direction?: Property.Direction;
  alignItems?: Property.AlignItems;
  justifyContent?: Property.JustifyContent;
  wrap?: Property.FlexWrap;
  gap?: Property.Gap;
  width?: Property.Width;
}

export const FlexContainer = styled.div<IFlexContainerProps>(
  ({ alignItems, justifyContent, direction, wrap, gap, inline, width }) => ({
    display: inline ? "inline-flex" : "flex",
    flexWrap: wrap,
    alignItems,
    justifyContent,
    direction,
    gap,
    width,
  }),
);

export interface IFlexChildProps {
  grow?: Property.FlexGrow;
  shrink?: Property.FlexShrink;
  overflowX?: Property.Overflow;
  overflowY?: Property.Overflow;
  overflow?: Property.Overflow;
}

export const FlexChild = styled.div<IFlexChildProps>`
  ${({ grow, shrink, overflowX, overflowY, overflow }) => `
    ${grow !== undefined ? `flex-grow: ${grow};` : ""}
    ${shrink !== undefined ? `flex-shrink: ${shrink};` : ""}
    ${overflowX !== undefined ? `overflow-x: ${overflowX};` : ""}
    ${overflowY !== undefined ? `overflow-y: ${overflowY};` : ""}
    ${overflow !== undefined ? `overflow: ${overflow};` : ""}
  `}
`;
